<template>
    <div class="container-fluid" style="width: 820px;">
        <!--Heading-->

        <div class="row">
            <div class="col-6 m-b-30">
                <h2 class="m-b-0">Sale Order #{{so.id}}</h2>
            </div>
            <div class="col-6 text-right">
                <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true"
                            class="btn waves-effect waves-light btn-outline-success dropdown-toggle"
                            data-toggle="dropdown" type="button">
                        Action
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" data-target="#attachmentModal" data-toggle="modal"
                           href="javascript:void(0)">Upload Attachment</a>
                        <a class="dropdown-item" data-target="#storedAttachmentModal" data-toggle="modal"
                           href="javascript:void(0)">View Attachment</a>
                        <a class="dropdown-item" href="javascript:void(0)">Void</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0)">Export as PDF</a>
                        <a @click="printSale()" class="dropdown-item" href="javascript:void(0)">Print</a>
                    </div>
                </div>
            </div>
        </div>

        <!--Quick Summary-->

        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3>
                            <span class="label label-cyan" v-if="so.status === 'DRAFT'">Draft</span>
                            <span class="label label-primary" v-if="so.status === 'CONFIRMED'">Confirmed</span>
                            <span class="label label-indigo" v-if="so.status === 'INVOICED'">Invoiced</span>
                            <span class="label label-brown" v-if="so.status === 'DROP_SHIPMENT'">Drop Shipment</span>
                            <span class="label label-orange" v-if="so.status === 'BACK_ORDER'">Back Order</span>
                            <span class="label label-success" v-if="so.status === 'PACKED'">Packed</span>
                            <span class="label label-light-green" v-if="so.status === 'SHIPPED'">Shipped</span>
                            <span class="label label-dark-green" v-if="so.status === 'FULFILLED'">Fulfilled</span>
                        </h3>
                        <span>Status</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 class="font-medium m-b-0" v-if="currentOrg.type === 'COOP'">{{so.buyer.biz_name}}</h3>
                        <h3 class="font-medium m-b-0" v-if="currentOrg.type === 'COOP_MEMBER'">
                            {{so.seller.biz_name}}</h3>
                        <span v-if="currentOrg.type === 'COOP'">Buyer</span>
                        <span v-if="currentOrg.type === 'COOP_MEMBER'">Seller</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 class="font-medium m-b-0">{{so.total | money}}</h3>
                        <span>Sale Amount</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 text-right">
                <div class="ml-auto">
                    <div>
                        <h3 class="font-medium text-right m-b-0">{{so.created_at || "—" | medium}}</h3>
                        <span class="text-right">Due Date</span>
                    </div>
                </div>
            </div>
        </div>

        <!--Action Cards-->

        <div class="row m-t-20">
            <div class="col-lg-12 col-md-12">
                <div class="card" v-bind:class="{'card-highlighted': !isDraft()}">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="!isDraft()">1</div>
                                    <div class="step-badge-inner step-badge-inner-checked" v-if="isDraft()">
                                        <i class="fas fa-check"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Create Sale Order</h3>
                                <h6 class="text-dark">Created: {{so.created_at | long}}</h6>
                            </div>
                            <div class="ml-auto">
                                <div class="button-group">
                                    <button @click="editSo()" class="btn waves-effect waves-light btn-outline-success"
                                            type="button" v-if="isAdmin() && !isBuyer() &&  so.status === 'DRAFT'">
                                        Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-link"></div>
                <div class="card" v-bind:class="{'card-highlighted': !isConfirmed()}">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="!isConfirmed()">2</div>
                                    <div class="step-badge-inner step-badge-inner-checked" v-if="isConfirmed()">
                                        <i class="fas fa-check"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Confirmation</h3>
                                <h6 class="text-dark" v-if="!so.transition">Confirmed: Awaiting Confirmation</h6>
                                <h6 class="text-dark" v-if="so.transition">Confirmed: {{so.transition['CONFIRMED'] |
                                    long}}</h6>
                            </div>
                            <div class="ml-auto">
                                <div class="button-group">
                                    <button @click="confirmSale"
                                            class="btn waves-effect waves-light btn-outline-success" type="button"
                                            v-if="!isConfirmed() && !isBuyer() && isAdmin()">
                                        Confirm
                                    </button>
                                    <button @click="newInvoice()"
                                            class="btn waves-effect waves-light btn-outline-success" type="button"
                                            v-if="!isBuyer() && isConfirmed() && !isDropShipped()">
                                        Invoice
                                    </button>
                                    <button @click="dropShipment()"
                                            class="btn waves-effect waves-light btn-outline-success" type="button"
                                            v-if="!isBuyer() && isConfirmed() && !isInvoiced() && !isDropShipped()">
                                        Drop Shipment
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-link"></div>
                <div class="card" v-bind:class="{'card-highlighted': !isFulfilled()}">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="!isFulfilled()">3</div>
                                    <div class="step-badge-inner step-badge-inner-checked" v-if="isFulfilled()">
                                        <i class="fas fa-check"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Fulfillment</h3>
                                <h6 class="text-dark" v-if="!isFulfilled()">Status: Awaiting Fulfillment</h6>
                                <h6 class="text-dark" v-if="isFulfilled()">Fulfilled: {{so.transition.FULFILLED |
                                    long}}</h6>
                            </div>
                            <div class="ml-auto">
                                <div class="button-group">
                                    <button @click="pack()" class="btn waves-effect waves-light btn-outline-success"
                                            type="button"
                                            v-if="!isBuyer() && ['INVOICED','BACK_ORDER'].includes(so.status)">
                                        Pack
                                    </button>
                                    <button @click="pack()" class="btn waves-effect waves-light btn-outline-success"
                                            type="button" v-if="so.status === 'PACKED'">
                                        View Packaging
                                    </button>
                                    <button @click="ship()" class="btn waves-effect waves-light btn-outline-success"
                                            type="button" v-if="!isBuyer() && so.status === 'PACKED'">
                                        Ship
                                    </button>
                                    <button @click="fulfill()" class="btn waves-effect waves-light btn-outline-success"
                                            type="button"
                                            v-if="!isBuyer() && (so.status === 'SHIPPED' || so.status === 'DROP_SHIPMENT')">
                                        Fulfill
                                    </button>
                                    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade"
                                         id="attachmentModal" role="dialog" tabindex="-1">
                                        <div class="modal-dialog modal-lg">
                                            <div class="modal-content">
                                                <form>
                                                    <div class="modal-header">
                                                        <h4 class="modal-title" id="attachmentModalLabel">
                                                            Attachments</h4>
                                                        <button @click="closeAttachmentModal()" aria-hidden="true"
                                                                class="close" data-dismiss="modal" type="button">×
                                                        </button>
                                                    </div>
                                                    <div class="modal-body card-blue">
                                                        <div class="card-body">
                                                            <div class="form-group row">
                                                                <div class="col-sm-12">
                                                                    <input
                                                                            class="form-control"
                                                                            name="file_title"
                                                                            placeholder="Title"
                                                                            style="height: 42px;"
                                                                            type="text"
                                                                            v-model="fileTitle">
                                                                </div>
                                                            </div>
                                                            <div class="form-group row">
                                                                <div class="col-sm-12">
                                                                <textarea
                                                                        class="form-control"
                                                                        data-vv-as="description"
                                                                        id="description"
                                                                        name="description"
                                                                        placeholder="File Description"
                                                                        rows=3
                                                                        v-model="fileDesc">
                                                                </textarea>
                                                                </div>
                                                            </div>
                                                            <div class="form-group row">
                                                                <div class="input-group col-md-8">
                                                                    <div class="custom-file">
                                                                        <input @change="onFileChange"
                                                                               class="custom-file-input"
                                                                               id="inputGroupFile01"
                                                                               ref="file"
                                                                               type="file">
                                                                        <label class="custom-file-label"
                                                                               for="inputGroupFile01"
                                                                               style="cursor: pointer">{{filename}}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="table-responsive p-t-25"
                                                                 v-if="attachments.length >0">
                                                                <table class="table no-wrap v-middle">
                                                                    <thead>
                                                                    <tr class="bg-light">
                                                                        <th><h6>File Name</h6></th>
                                                                        <th><h6>Title</h6></th>
                                                                        <th><h6>Description</h6></th>
                                                                        <th><h6>Action</h6></th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    <tr v-bind:key="index"
                                                                        v-for="(a, index) in attachments">
                                                                        <td>{{a.filename}}</td>
                                                                        <td>{{a.title}}</td>
                                                                        <td>{{a.desc}}</td>
                                                                        <td>
                                                                            <a @click="deleteFile(a.id, a.filepath)"
                                                                               class="text-danger"
                                                                               href="javasript:void(0);">
                                                                                <b>Remove</b>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button @click="saveAttachment()" class="btn btn-success"
                                                                data-dismiss="modal" type="button">Submit
                                                        </button>
                                                        <button @click="closeAttachmentModal()"
                                                                class="btn waves-effect waves-light btn-danger"
                                                                data-dismiss="modal"
                                                                type="button">Cancel
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade"
                                         id="storedAttachmentModal" role="dialog" tabindex="-1">
                                        <div class="modal-dialog modal-lg">
                                            <div class="modal-content">
                                                <form>
                                                    <div class="modal-header">
                                                        <h4 class="modal-title" id="storedAttachmentModalLabel">Stored
                                                            Attachments</h4>
                                                        <button aria-hidden="true" class="close" data-dismiss="modal"
                                                                type="button">×
                                                        </button>
                                                    </div>
                                                    <div class="modal-body card-blue">
                                                        <div class="card-body">
                                                            <h5 class="text-teal text-center"
                                                                v-if="storedAttachment.length ===0">No Attachment
                                                                found</h5>
                                                            <div class="table-responsive"
                                                                 v-if="storedAttachment.length >0">
                                                                <table class="table no-wrap v-middle">
                                                                    <thead>
                                                                    <tr class="bg-light">
                                                                        <th class="border-0"><h6>File Name</h6></th>
                                                                        <th class="border-0"><h6>Title</h6></th>
                                                                        <th class="border-0"><h6>Description</h6></th>
                                                                        <th class="border-0"><h6>Action</h6></th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    <tr v-bind:key="index"
                                                                        v-for="(a, index) in storedAttachment">
                                                                        <td>{{a.filename}}</td>
                                                                        <td>{{a.title}}</td>
                                                                        <td>{{a.desc}}</td>
                                                                        <td>
                                                                            <a @click="downloadFile(a.filename)"
                                                                               class="text-info"
                                                                               href="javasript:void(0);">
                                                                                <b>Download</b>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button class="btn waves-effect waves-light btn-danger"
                                                                data-dismiss="modal"
                                                                type="button">Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row hide">
            <div class="col-md-12">
                <div class="card card-body printableArea" id="printMe">
                    <h3 class="m-t-15"><b>Sale Order</b> <span class="pull-right">#&nbsp;{{so.id}}</span></h3>
                    <hr>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="pull-left">
                                <address>
                                    <h3><b class="text-danger">{{so.seller.biz_name}}</b></h3>
                                    <p class="text-muted m-l-5">{{so.seller.line1}},&nbsp;{{so.seller.line2}},
                                        <br/>{{so.seller.country}},&nbsp;{{so.seller.city}},
                                        <br/>{{so.seller.state}},&nbsp;{{so.seller.postal_code}}</p>
                                </address>
                            </div>
                            <div class="pull-right text-right">
                                <address>
                                    <h3>Sold To,</h3>
                                    <h4 class="font-bold">{{so.buyer.biz_name}}</h4>
                                    <p class="text-muted m-l-30">{{so.buyer.line1}},&nbsp;{{so.buyer.line2}},
                                        <br/>{{so.buyer.country}},&nbsp;{{so.buyer.city}},
                                        <br/>{{so.buyer.state}},&nbsp;{{so.buyer.postal_code}}</p>
                                    <p class="m-t-30"><b>Sale Order Date :</b>&nbsp;{{so.created_at | date}}</p>
                                </address>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive m-t-40" style="clear: both;">
                                <table class="table table-hover table-bordered">
                                    <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Item</th>
                                        <th>Description</th>
                                        <th class="text-right">Quantity</th>
                                        <th class="text-right">Unit Cost</th>
                                        <th class="text-right">Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-bind:key="index" v-for="(si, index) in so.items">
                                        <td class="text-center">{{index + 1}}</td>
                                        <td>{{si.name}}</td>
                                        <td v-if="si.description">{{si.description | truncate(20, '...')}}</td>
                                        <td class="text-right">{{si.quantity | units}}</td>
                                        <td class="text-right">{{si.rate | money}} / {{si.unit_symbol}}</td>
                                        <td class="text-right">{{si.amount | money}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr>
                        <div class="col-md-12 m-t-30 ">
                            <hr>
                            <div class="pull-right text-right">
                                <h3><b>Total :</b>&nbsp;<span v-if="so.total.amount">{{so.total | money}}</span></h3>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h3>Sale Order&nbsp;#{{so.id}}</h3>
                                <h4 v-if="so.invoice_id">
                                    <a @click="viewInvoice(so.invoice_id)" href="javascript:void(0)">Invoice
                                        #{{so.invoice_id}}</a>
                                </h4>
                            </div>
                            <div class="ml-auto">
                                <div class="d-flex">
                                    <div class="m-r-20">
                                        <blockie :address="so.seller.biz_email" :width="70"
                                                 v-if="!orgImg && so.seller.biz_email"></blockie>
                                        <img :src="orgImg" class="rounded-circle" height="100" v-if="orgImg"
                                             width="100"/>
                                    </div>
                                    <address>
                                        <h3>{{so.seller.name}}</h3>
                                        <p class="text-muted m-l-5">
                                            <i class="fas fa-phone"></i>&nbsp;{{so.seller.biz_phone}}<br/>
                                            <i class="fas fa-envelope"></i>&nbsp;{{so.seller.biz_email}}
                                        </p>
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="card card-body printableArea">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="pull-left">
                                    <span>Sold To:</span>
                                    <h3>{{so.buyer.name}}</h3>
                                    <p class="text-muted m-l-5">
                                        <i class="fas fa-phone"></i>&nbsp;{{so.buyer.biz_phone}}<br/>
                                        <i class="fas fa-envelope"></i>&nbsp;{{so.buyer.biz_email}}
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="pull-right">
                                    <dl class="row mb-0">
                                        <div class="col-sm-6 text-sm-right">
                                            <dt>SO Date</dt>
                                        </div>
                                        <div class="col-sm-6 text-sm-left">
                                            <dd class="mb-1">{{so.created_at | date}}</dd>
                                        </div>
                                    </dl>
<!--                                    <dl class="row mb-0">-->
<!--                                        <div class="col-sm-6 text-sm-right">-->
<!--                                            <dt>Transaction</dt>-->
<!--                                        </div>-->
<!--                                        <div class="col-sm-6 text-sm-left">-->
<!--                                            <dd class="mb-1" v-if="so.tx">-->
<!--                                                <a class="ellipsis" target="_blank"-->
<!--                                                   v-bind:href="this.$BORLAUG + '/tx/' + so.tx">{{so.tx}}</a>-->
<!--                                            </dd>-->
<!--                                        </div>-->
<!--                                    </dl>-->
<!--                                    <dl class="row mb-0">-->
<!--                                        <div class="col-sm-6 text-sm-right">-->
<!--                                            <dt>Contract</dt>-->
<!--                                        </div>-->
<!--                                        <div class="col-sm-6 text-sm-left">-->
<!--                                            <dd class="mb-1">-->
<!--                                                <a class="ellipsis" target="_blank"-->
<!--                                                   v-bind:href="this.$BORLAUG + '/address/' + so.contract">{{so.contract}}</a>-->
<!--                                            </dd>-->
<!--                                        </div>-->
<!--                                    </dl>-->
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive m-t-40" style="clear: both;">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th class="text-center">#</th>
                                            <th>Item</th>
                                            <th class="text-right">Quantity</th>
                                            <th class="text-right">Unit Cost</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(si, index) in so.items">
                                            <td class="text-center">{{index + 1}}</td>
                                            <td>{{si.name}}</td>
                                            <td class="text-right">{{si.quantity | units}}</td>
                                            <td class="text-right">{{si.rate | money}} / {{si.unit_symbol}}</td>
                                            <td class="text-right">{{si.amount | money}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <hr>
                                <div class="pull-right m-t-30 text-right">
                                    <h3>Total: {{so.total | money}}</h3>
                                </div>
                                <div class="clearfix"></div>
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from '../../../common/Blockie';
    import _ from "lodash";
    import axios from 'axios';
    import uuid from "uuid/v4";

    export default {
        name: "ViewSaleOrder",
        props: ["saleid"],
        components: {Blockie},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                so: {
                    total: 0,
                    seller: {},
                    buyer: {},
                    items: []
                },
                orgImg: null,
                file: File,
                filename: "Upload Attachment",
                uploadstatus: '',
                attachments: [],
                isLoading: false,
                fileTitle: '',
                fileDesc: '',
                storedAttachment: []
            };
        },
        mounted() {
            this.init();
            this.$root.$on('refreshSo', () => {
                this.init();
            })
        },
        methods: {
            async init() {
                await this.getSaleOrder();
                await this.getAttachment();
            },
            isAdmin() {
                return this.currentOrg && this.currentOrg.role === 'ORG_ADMIN';
            },
            isDraft() {
                return ['DRAFT', 'CONFIRMED', 'INVOICED', 'DROP_SHIPMENT', 'BACK_ORDER', 'PACKED', 'SHIPPED', 'FULFILLED', 'CLOSED'].includes(this.so.status);
            },
            isConfirmed() {
                return ['CONFIRMED', 'DROP_SHIPMENT', 'BACK_ORDER', 'PACKED', 'INVOICED', 'SHIPPED', 'FULFILLED', 'CLOSED'].includes(this.so.status);
            },
            isInvoiced() {
                return ['INVOICED', 'BACK_ORDER', 'PACKED', 'SHIPPED', 'FULFILLED', 'CLOSED'].includes(this.so.status);
            },
            isDropShipped() {
                return ['DROP_SHIPMENT', 'FULFILLED', 'CLOSED'].includes(this.so.status);
            },
            isFulfilled() {
                return this.so.status === 'FULFILLED';
            },
            async getSaleOrder() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/sales/" + this.saleid);

                $(".preloader").fadeOut();
                this.so = reply.data;
                // console.log(this.so)
            },
            async confirmSale() {
                await this.$http.post("/marketplaces/" + this.currentOrg.marketplace_id + "/sales/" + this.saleid + "/confirm");
                this.$toastr('success', 'Sale order confirmed.', 'Sale Confirmed');
                this.getSaleOrder();
            },
            async newInvoice() {
                let invoice = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/invoice`);
                await this.$router.push({name: "viewmarketplaceinvoice", params: {invoiceid: invoice.data.invoice_id}});
                this.$toastr('success', `Invoice ${invoice.data.invoice_id} has been created successfully`, 'Invoice created');
            },
            async dropShipment() {
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/dropShipment`);
                this.$toastr('success', 'Drop shipment initiated', 'Shipment');
                this.getSaleOrder();
            },
            editSo() {
                this.$router.push({name: "editsale", params: {saleid: this.saleid}});
            },
            viewInvoice(invoiceid) {
                this.$router.push({name: "viewinvoice", params: {invoiceid: invoiceid}});
            },
            pack() {
                this.$router.push({name: 'pack', saleid: this.saleid});
            },
            async ship() {
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/ship`);
                this.$toastr('success', 'Commodities shipped.', 'Shipped');
                this.getSaleOrder();
            },
            async fulfill() {
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/fulfill`);
                this.$toastr('success', 'Order fulfilled', 'Fulfilled');
                this.getSaleOrder();
            },
            isBuyer() {
                return this.currentOrg.id === this.so.buyer_id;
            },
            async onFileChange(e) {
                this.file = this.$refs.file.files[0];
                this.filename = this.file.name;
                this.uploadFile();
            },
            async uploadFile() {
                this.uploadstatus = "Uploading File Please Wait";
                let signedurl = await this.getUploadUrl();
                await axios.put(signedurl, this.file);
                this.resetAttachment();
            },
            async getUploadUrl() {
                let signedUrl = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/attachments/signedurl`, {
                    params: {
                        name: this.filename,
                        type: 'write'
                    }
                });

                let parts = this.filename.split(".");
                this.attachments.push({
                    id: uuid(),
                    filename: this.filename,
                    title: this.fileTitle,
                    desc: this.fileDesc,
                    filepath: signedUrl.data.key,
                    contenttype: parts[parts.length - 1]
                });

                return signedUrl.data.url;
            },
            async getDownloadUrl(filename) {
                let signedUrl = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/attachments/signedurl`, {
                    params: {
                        name: filename,
                        type: 'read'
                    }
                });
                return signedUrl.data.url;
            },
            async saveAttachment() {
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/attachments`, {
                    attachments: this.attachments
                });
                this.uploadstatus = "";
                this.attachments = [];
                this.resetAttachment();
                this.getAttachment();
                this.$toastr('success', 'Attachment uploaded successfully', 'Success');
            },
            async getAttachment() {
                try {
                    let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/attachments`);
                    this.storedAttachment = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async downloadFile(filename) {
                let signedUrl = await this.getDownloadUrl(filename);
                let link = document.createElement('a');
                link.download = filename;
                link.href = signedUrl;
                link.click();
            },
            async deleteFile(id, filepath) {
                await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.saleid}/attachments`, {
                    data: {
                        filepath: filepath
                    }
                });
                _.remove(this.attachments, function (a) {
                    return a.id == id;
                });
                this.attachments = JSON.parse(JSON.stringify(this.attachments));
                this.resetAttachment();
                this.$toastr('success', 'Attachment deleted successfully', 'Success');
            },
            closeAttachmentModal() {
                this.attachments = [];
                this.resetAttachment();
            },
            resetAttachment() {
                this.file = File;
                this.filename = "Upload Attachment";
                this.fileTitle = "";
                this.fileDesc = "";
            },
            printSale() {
                this.$htmlToPaper('printMe');
            }
        }
    }
</script>

<style scoped>
    .step-badge {
        color: #cdd1d3;
        float: left;
        font-size: 25px;
        line-height: 50px;
        margin-right: 18px;
        text-align: center;
        border-width: 2px;
    }

    .step-badge-inner {
        background: #fff;
        border: 2px solid #019b40;
        border-radius: 50%;
        color: #019b40;
        width: 50px;
        height: 50px;
        line-height: 46px;
        box-sizing: border-box;
    }

    .step-badge-inner-checked {
        color: #fff;
        background: #019b40;
        border-color: #019b40;
        line-height: 50px;
    }

    a.ext-link {
        cursor: pointer;
        color: #2962FF;
    }
</style>
